// Utils
import {
    formatPrice,
    formatNumber,
} from '@shared/utils/formatter.js';
import {
    capitaliseString,
} from '@shared/utils/general';
import {
    format,
} from '@shared/utils/dates.js';

// Types
import {
    OrderDetails,
    OrderStatus,
} from '@webapp/types/trading';

type ProcessedOrderDetails = OrderDetails & { percentage: number; date: string };

// ToDo - Replace Record<string, unknown> with Partner type once implemented
interface FormattedOrderDetails {
    id: string;
    date: string;
    status: string;
    executedPrice: string;
    executedQuantity: string;
    partner: Record<string, unknown>;
    quantity: string;
    orderType: string;
    symbols: string;
    orderPrice: string;
    orderProgress: number;
    amount: string;
    fee: string;
}

const mapOrdersDetails = (orders: OrderDetails[]): ProcessedOrderDetails[] => orders.map(({
    executedQuantity,
    createdAt,
    initialQuantity,
    initialPrice,
    side,
    status,
    ...order
}) => ({
    ...order,
    executedQuantity,
    createdAt,
    initialQuantity,
    initialPrice,
    side,
    status,
    percentage: Number(executedQuantity) / Number(initialQuantity) * 100,
    date: format(new Date(createdAt), 'dateShort'),
    time: format(new Date(createdAt), 'time'),
    amount: formatPrice(initialQuantity),
    price: formatPrice(initialPrice),
    sideClass: `row-data--${side}`,
    progressColor: status === OrderStatus.Completed
        ? '#8fc741'
        : getProgressColor(side),
}));

// ToDo - Replace with proper Partner typing once created
const formatSingleOrderDetails = (partner: Record<string, unknown>, {
    id,
    initialQuantity,
    side,
    status,
    date,
    initialPrice,
    percentage,
    transactions,
    market,
    executedPrice = '0',
    executedQuantity = '0',
}: ProcessedOrderDetails): FormattedOrderDetails => {
    const {
        quoteCurrency: {
            shortCode = 'CHZ',
        } = {},
        symbol = '',
    } = {
        ...market,
    };

    return {
        id,
        date,
        partner: partner ?? {},
        quantity: formatNumber(initialQuantity),
        orderType: capitaliseString(side),
        status: capitaliseString(status),
        symbols: symbol,
        orderPrice: formatPrice(initialPrice, shortCode, true),
        executedPrice: formatPrice(executedPrice, shortCode, true),
        executedQuantity: formatNumber(executedQuantity),
        orderProgress: Math.trunc(percentage),
        amount: formatPrice(transactions.user_lock?.totalAmount ?? 0, shortCode, true),
        fee: formatPrice(transactions.user_lock?.fee.amount ?? 0, shortCode, true),
    };
};

const getProgressColor = (side: string): string => {
    switch (side) {
        case 'buy':
            return '#ffa101';
        case 'sell':
            return '#007aff';
        default:
            return '';
    }
};

export {
    mapOrdersDetails,
    formatSingleOrderDetails,
};